export const ADMIN_TAB_LIST = [
  { label: "Users", value: "users" },
  { label: "Service Groups and Roles", value: "service-groups" },
  { label: "Rate Cards", value: "rate-cards" },
];
